var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var staticMethods = require('./static-methods');

Object.keys(staticMethods).forEach(function (methodName) {
  var instaceMethodName = methodName.charAt(0).toUpperCase() + methodName.slice(1);
  exports["async".concat(instaceMethodName)] =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var _len,
        args,
        _key,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = _args[_key];
            }

            return _context.abrupt("return", staticMethods[methodName].apply(staticMethods, [this].concat(args)));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
});